import { getLoanType } from "../../config/config";

export function resolveLoanTypeDisplayTitle({
  loanTypeDisplayName,
  loanTypeProp,
  loanType
}: {
  loanTypeDisplayName?: string;
  loanTypeProp?: string;
  loanType?: string;
}): string {
  if (loanTypeDisplayName) {
    return loanTypeDisplayName;
  }
  if ([loanTypeProp, loanType].includes(getLoanType[1].displayValue)) {
    return `${getLoanType[1].name}`;
  }
  if ([loanTypeProp, loanType].includes(getLoanType[2].displayValue)) {
    return `${getLoanType[2].name}`;
  }
  return `${getLoanType[0].name}`;
}
